import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
// import PropTypes from 'prop-types';
import clsx from 'clsx';
import DateUtils from '../../utils/date';
import withTheme from '../../theme/withTheme';
import SlideTransition from '../../Transitions/Slide';
import Day from '../CalendarDay/Day';
import DayView from '../CalendarDay/DayView';
import CalendarHeader from '../CalendarHeader';
import { findClosestEnabledDate } from '../helpers';
import { runKeyHandler } from '../hooks/useKeyDown';
import { CalendarWrapper, Week } from './styles';
var utils = new DateUtils();
var getDirection = function getDirection(nextDate, lastDate) {
  return utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right';
};
var KeyDownListener = function KeyDownListener(_ref) {
  var onKeyDown = _ref.onKeyDown;
  React.useEffect(function () {
    window.addEventListener('keydown', onKeyDown);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
  return null;
};
var Calendar = /*#__PURE__*/function (_React$Component) {
  function Calendar(props) {
    var _this;
    _classCallCheck(this, Calendar);
    _this = _callSuper(this, Calendar, [props]);
    _this.state = {
      slideDirection: 'left',
      currentMonth: utils.startOfMonth(props.date),
      loadingQueue: 0
    };
    _this.moveToDay = _this.moveToDay.bind(_this);
    _this.pushToLoadingQueue = _this.pushToLoadingQueue.bind(_this);
    _this.popFromLoadingQueue = _this.popFromLoadingQueue.bind(_this);
    _this.validateMinMaxDate = _this.validateMinMaxDate.bind(_this);
    _this.shouldDisablePrevMonth = _this.shouldDisablePrevMonth.bind(_this);
    _this.shouldDisableNextMonth = _this.shouldDisableNextMonth.bind(_this);
    _this.shouldDisableDate = _this.shouldDisableDate.bind(_this);
    _this.renderDays = _this.renderDays.bind(_this);
    _this.renderWeeks = _this.renderWeeks.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    _this.onSelectDayHandler = _this.onSelectDayHandler.bind(_this);
    _this.onMonthChangeHandler = _this.onMonthChangeHandler.bind(_this);
    return _this;
  }
  _inherits(Calendar, _React$Component);
  return _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        date = _this$props.date,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate,
        disablePast = _this$props.disablePast,
        disableFuture = _this$props.disableFuture;
      if (this.shouldDisableDate(date)) {
        var closestEnabledDate = findClosestEnabledDate({
          date: date,
          utils: utils,
          minDate: utils.date(minDate),
          maxDate: utils.date(maxDate),
          disablePast: Boolean(disablePast),
          disableFuture: Boolean(disableFuture),
          shouldDisableDate: this.shouldDisableDate
        });
        this.onSelectDayHandler(closestEnabledDate, false);
      }
    }
  }, {
    key: "onMonthChangeHandler",
    value: function onMonthChangeHandler(newMonth, slideDirection) {
      var _this2 = this;
      var onMonthChange = this.props.onMonthChange;
      this.setState({
        currentMonth: newMonth,
        slideDirection: slideDirection
      });
      if (onMonthChange) {
        var returnVal = onMonthChange(newMonth);
        if (returnVal) {
          this.pushToLoadingQueue();
          returnVal.then(function () {
            _this2.popFromLoadingQueue();
          });
        }
      }
    }
  }, {
    key: "onSelectDayHandler",
    value: function onSelectDayHandler(day) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props2 = this.props,
        date = _this$props2.date,
        onChange = _this$props2.onChange;
      if (onChange) onChange(utils.mergeDateAndTime(day, date), isFinish);
    }
  }, {
    key: "onKeyDownHandler",
    value: function onKeyDownHandler(event) {
      var _this3 = this;
      var date = this.props.date;
      runKeyHandler(event, {
        ArrowUp: function ArrowUp() {
          return _this3.moveToDay(utils.addDays(date, -7));
        },
        ArrowDown: function ArrowDown() {
          return _this3.moveToDay(utils.addDays(date, 7));
        },
        ArrowLeft: function ArrowLeft() {
          return _this3.moveToDay(utils.addDays(date, -1));
        },
        ArrowRight: function ArrowRight() {
          return _this3.moveToDay(utils.addDays(date, 1));
        }
      });
    }
  }, {
    key: "moveToDay",
    value: function moveToDay(day) {
      var currentMonth = this.state.currentMonth;
      if (day && !this.shouldDisableDate(day)) {
        if (utils.getMonth(day) !== utils.getMonth(currentMonth)) {
          this.onMonthChangeHandler(utils.startOfMonth(day), 'left');
        }
        this.onSelectDayHandler(day, false);
      }
    }
  }, {
    key: "shouldDisablePrevMonth",
    value: function shouldDisablePrevMonth() {
      var _this$props3 = this.props,
        disablePast = _this$props3.disablePast,
        minDate = _this$props3.minDate;
      var currentMonth = this.state.currentMonth;
      var now = utils.date();
      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
      return !utils.isBefore(firstEnabledMonth, currentMonth);
    }
  }, {
    key: "shouldDisableNextMonth",
    value: function shouldDisableNextMonth() {
      var _this$props4 = this.props,
        disableFuture = _this$props4.disableFuture,
        maxDate = _this$props4.maxDate;
      var currentMonth = this.state.currentMonth;
      var now = utils.date();
      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
      return !utils.isAfter(lastEnabledMonth, currentMonth);
    }
  }, {
    key: "shouldDisableDate",
    value: function shouldDisableDate(day) {
      var shouldDisableDate = this.props.shouldDisableDate;
      return this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
    }
  }, {
    key: "validateMinMaxDate",
    value: function validateMinMaxDate(day) {
      var _this$props5 = this.props,
        minDate = _this$props5.minDate,
        maxDate = _this$props5.maxDate,
        disableFuture = _this$props5.disableFuture,
        disablePast = _this$props5.disablePast;
      var now = utils.date();
      return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
    }
  }, {
    key: "pushToLoadingQueue",
    value: function pushToLoadingQueue() {
      this.setState(function (prevState) {
        return {
          loadingQueue: prevState.loadingQueue + 1
        };
      });
    }
  }, {
    key: "popFromLoadingQueue",
    value: function popFromLoadingQueue() {
      this.setState(function (prevState) {
        return {
          loadingQueue: prevState.loadingQueue <= 0 ? 0 : prevState.loadingQueue - 1
        };
      });
    }
  }, {
    key: "renderWeeks",
    value: function renderWeeks() {
      var _this4 = this;
      var currentMonth = this.state.currentMonth;
      var weeks = utils.getWeekArray(currentMonth);
      return weeks.map(function (week) {
        return /*#__PURE__*/React.createElement(Week, {
          key: "week-".concat(week[0].toString())
        }, _this4.renderDays(week));
      });
    }
  }, {
    key: "renderDays",
    value: function renderDays(week) {
      var _this5 = this;
      var _this$props6 = this.props,
        date = _this$props6.date,
        renderDay = _this$props6.renderDay;
      var currentMonth = this.state.currentMonth;
      var now = utils.date();
      var selectedDate = utils.startOfDay(date);
      var currentMonthNumber = utils.getMonth(currentMonth);
      return week.map(function (day) {
        var disabled = _this5.shouldDisableDate(day);
        var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
        var variant = clsx(!isDayInCurrentMonth && "hidden", utils.isSameDay(selectedDate, day) && "selected", utils.isSameDay(day, now) && "current").split(' ')[0];
        var dayComponent = /*#__PURE__*/React.createElement(Day, {
          variant: variant || undefined,
          disabled: disabled
        }, utils.getDayText(day));
        if (renderDay) {
          dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
        }
        return /*#__PURE__*/React.createElement(DayView, {
          value: day,
          key: day.toString(),
          disabled: disabled,
          dayInCurrentMonth: isDayInCurrentMonth,
          onSelect: _this5.onSelectDayHandler
        }, dayComponent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        currentMonth = _this$state.currentMonth,
        slideDirection = _this$state.slideDirection,
        loadingQueue = _this$state.loadingQueue;
      var _this$props7 = this.props,
        classes = _this$props7.classes,
        _this$props7$allowKey = _this$props7.allowKeyboardControl,
        allowKeyboardControl = _this$props7$allowKey === void 0 ? true : _this$props7$allowKey,
        leftArrowIcon = _this$props7.leftArrowIcon,
        rightArrowIcon = _this$props7.rightArrowIcon,
        loadingIndicator = _this$props7.loadingIndicator,
        theme = _this$props7.theme;
      var loadingElement = loadingIndicator;
      return /*#__PURE__*/React.createElement(React.Fragment, null, allowKeyboardControl && /*#__PURE__*/React.createElement(KeyDownListener, {
        onKeyDown: this.onKeyDownHandler
      }), /*#__PURE__*/React.createElement(CalendarWrapper, {
        theme: theme
      }, /*#__PURE__*/React.createElement(CalendarHeader, {
        currentMonth: currentMonth,
        slideDirection: slideDirection,
        onMonthChange: this.onMonthChangeHandler,
        leftArrowIcon: leftArrowIcon,
        rightArrowIcon: rightArrowIcon,
        disablePrevMonth: this.shouldDisablePrevMonth(),
        disableNextMonth: this.shouldDisableNextMonth()
      }), /*#__PURE__*/React.createElement(SlideTransition, {
        direction: slideDirection,
        transitionKey: currentMonth.toString(),
        style: {
          minHeight: '242px'
        }
      }, /*#__PURE__*/React.createElement(React.Fragment, null, loadingQueue > 0 && /*#__PURE__*/React.createElement("div", {
        className: classes.progressContainer
      }, loadingElement) || /*#__PURE__*/React.createElement("div", null, this.renderWeeks())))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var nextDate = nextProps.date;
      if (!utils.isEqual(nextDate, state.lastDate)) {
        var nextMonth = utils.getMonth(nextDate);
        var lastDate = state.lastDate || nextDate;
        var lastMonth = utils.getMonth(lastDate);
        return {
          lastDate: nextDate,
          currentMonth: utils.startOfMonth(nextDate),
          slideDirection: nextMonth === lastMonth ? state.slideDirection : getDirection(nextDate, lastDate)
        };
      }
      return null;
    }
  }]);
}(React.Component);
export default withTheme(Calendar);